<template>
    <div class="main-container" justify="space-around" style="padding: 2rem;">
        <h2>{{ "Make payments via CSV" | t }}</h2>
        <v-row>
            <p class="pl-3">
                Here you can generate payment links. The only acceptable format is CSV. File must be less than 10MB.
                Below is an example of what the file should look like. Parameters marked with * are required. Both
                Estonian and English language options are supported. Please choose one version.
            </p>
        </v-row>

        <v-row justify="center">
            <v-simple-table>
                <thead>
                    <tr>
                        <th>
                            Makse saaja/Recipient name*
                        </th>
                        <th>
                            IBAN*
                        </th>
                        <th>
                            Viitenumber/Reference number
                        </th>
                        <th>
                            Summa/Sum*
                        </th>
                        <th>
                            Maksetähtaeg/Deadline
                        </th>
                        <th>
                            Kirjeldus/Description
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Tarkpay OÜ</td>
                        <td>EE7300...</td>
                        <td>703682</td>
                        <td>10,25</td>
                        <td>11.02.2021</td>
                        <td>Arve nr. 112</td>
                    </tr>
                    <tr>
                        <td v-for="i in 6" :key="i">...</td>
                    </tr>
                </tbody>
            </v-simple-table>
        </v-row>
        <v-row>
            <p class="pl-3">
                To get started, you need to upload a file here.
            </p>
        </v-row>
        <v-row justify="center">
            <v-file-input
                show-size
                hide-details
                dense
                accept=".csv"
                :label="'Click here to upload' | t"
                prepend-icon="mdi-cloud-upload"
                v-model="fileUploadValue"
                @change="uploadCSV($event)"
            />
        </v-row>
        <v-row class="has-error" v-if="size_error">{{ "File size should be less than 10 MB!" | t }}</v-row>
    </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";

export default {
    name: "upload-csv",
    data() {
        return {
            fileUploadValue: null,
            size_error: false
        };
    },
    methods: {
        ...mapMutations(["setRequestError", "setErrorMessage"]),
        ...mapActions(["importCsvFile"]),
        async uploadCSV(e) {
            this.setRequestError(false);
            this.size_error = false;
            if (e && e.size > 0) {
                if (e.size < 10485760) {
                    await this.importCsvFile(e);
                    this.fileUploadValue = null;
                } else {
                    this.size_error = true;
                }
            }
        }
    }
};
</script>

<style scoped></style>
